// Button „Selbst berechnen“ (snippets/altruan-inko-rechner.liquid): beim Variantenwechsel
// nur zeigen, wenn die neue Variante zur HMV-Gruppe 15 gehört, und den Link auf sie setzen.
(() => {
  if (window.altruanInkoRechner) return;
  window.altruanInkoRechner = true;

  const aktualisiere = (variant) => {
    if (!variant || !variant.id) return;
    document.querySelectorAll("[data-altruan-inko-rechner]").forEach((el) => {
      if (variant.product_id && String(variant.product_id) !== el.dataset.productId) return;
      const ids = (el.dataset.varianten || "").split(",");
      const passt = ids.includes(String(variant.id));
      el.hidden = !passt;
      const link = el.querySelector("[data-altruan-inko-link]");
      if (passt && link) {
        const url = new URL(link.getAttribute("href"), window.location.origin);
        url.searchParams.set("variant", String(variant.id));
        link.setAttribute("href", url.pathname + url.search);
      }
    });
  };

  if (typeof subscribe === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
    subscribe(PUB_SUB_EVENTS.variantChange, (event) => aktualisiere(event && event.data && event.data.variant));
  }
})();
